import styled from "styled-components";

import { colors, breakpoints } from "definitions";

import DeleteIcon from "icons/cards/DeleteIcon";

import { field } from "basics/styles";

/* Cada archivo era una barra gris de 60px que se pintaba de azul de punta a
   punta: pesaba más que el propio cuestionario y el nombre quedaba en blanco
   sobre gris hasta terminar de subir. Ahora es una fila con el nombre, el
   botón de borrar y una línea fina de progreso abajo. */

export const Container = styled.li`
  position: relative;
  display: flex;
  align-items: center;
  gap: 1.2rem;
  width: 100%;
  min-height: 4.4rem;
  padding: 0.8rem 1.2rem;
  /* En los formularios oscuros el nombre del archivo va en blanco, así que la
     fila no puede quedar blanca: usa la superficie de fieldBox. */
  border: 1px solid
    ${({ mode }) => (mode === "dark" ? field.dark.border : "#dde3ee")};
  border-radius: 8px;
  background: ${({ mode }) =>
    mode === "dark" ? field.dark.surface : colors.background.white};
  overflow: hidden;

  ${breakpoints.phablet} {
    margin: 0;
  }
`;

// La línea de progreso: se pinta al pie de la fila y desaparece al llegar a 100.
export const ProgressDone = styled.div`
  position: absolute;
  left: 0;
  bottom: 0;
  height: 3px;
  width: 0;
  opacity: 0;
  background: ${colors.icons.yellowGreen};
  transition: width 0.4s ease, opacity 0.3s ease;
`;

export const Link = styled.a`
  flex: 1 1 auto;
  min-width: 0;
  font-family: Lato;
  font-size: 1.4rem;
  line-height: 2rem;
  text-decoration: none;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  color: ${({ mode }) =>
    mode === "dark" ? `${colors.fonts.white}` : `${colors.fonts.yellowGreen}`};

  :hover {
    text-decoration: underline;
  }
`;

export const Status = styled.span`
  flex: 0 0 auto;
  font-family: Lato;
  font-size: 1.2rem;
  color: ${({ mode }) => (mode === "dark" ? `${colors.fonts.white}` : "#7b889f")};
`;

export const DeleteButton = styled(DeleteIcon)`
  flex: 0 0 auto;
  width: 2rem;
  height: 2rem;
  cursor: pointer;
  fill: ${({ mode }) => (mode === "dark" ? field.dark.icon : "#9aa5b5")};

  :hover {
    fill: ${colors.background.red};
  }
`;
